import type { AppsFlyerClient } from './AppsFlyer.types';

export const disabledAppsFlyerClient: AppsFlyerClient = {
  initSdk: (_settings, callback) => {
    callback?.('disabled');
  },
  setCustomerUserId: (_userId, callback) => {
    callback?.('disabled');
  },
  logEvent: (_eventName, _eventValues, callback) => {
    callback?.('disabled');
  },
};
